import PropTypes from 'prop-types';

const User = {
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export const UserShape = PropTypes.shape(User);
export const UserExact = PropTypes.exact(User);
